<template>
  <div class="container">
    <div class="row vertical-center">
      <div class="col-12">
        <div class="ratio">
          <div id="viewport" ref="viewport"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PST from "../modules/ModVip"
import ModParticipant from "../modules/ModParticipant"
import ModTan from "../modules/ModTan"

export default {
  name: "ViewVip",
  mounted() {
    const self = this
    PST.init({
      viewport: "viewport",
      locale: self.$i18n.locale,
      baseUrl: "/proxy",
      success: async (status, result) => {
        if (status === 200) {
          ModParticipant.data.accountId = self.$specs.accountId
          ModParticipant.data.projectId = self.$specs.projectId
          ModParticipant.data.e = result.e
          ModParticipant.data.s = result.s
          ModParticipant.data.n = result.n
          ModParticipant.data.t = result.t
          ModParticipant.data.f = result.f
          ModParticipant.data.j = result.j
          ModParticipant.data.fulltype = result.type

          if (await ModParticipant.create(ModParticipant.data)) {
            if (
              await ModTan.invalidate(
                ModParticipant.data.tan,
                self.$specs.accountId,
                self.$specs.projectId
              )
            ) {
              self.$specs.withResult
                ? self.$router.push("/result")
                : self.$router.push("/end")
            } else {
              self.$router.push("/error")
            }
          } else {
            self.$router.push("/error")
          }
        } else {
          self.$router.push("/error")
        }
      },
    })
  },
}
</script>

<style>
.head {
  display: none !important;
}
</style>

<style scoped>
.view {
  position: absolute;
  width: 100%;
  top: 0px;
  bottom: 0px;
  background-color: lightgreen;
}
.vertical-center {
  min-height: 85%;
  min-height: 85vh;

  display: flex;
  align-items: center;
}
.ratio {
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
#viewport {
  display: block;
  height: auto;
  width: 100%;
}
.border {
  border: 1px solid #ddd;
}
h1 {
  font-weight: bold !important;
}
</style>
